<template>
  <Dialog
    v-model:visible="isVisible"
    modal
    :closable="false"
    :style="{ width: 'clamp(320px, 92vw, 1100px)' }"
    class="!bg-[var(--p-surface-100)] dark:!bg-[var(--p-surface-900)] px-8"
    @hide="handleClose"
  >
  <button
      type="button"
      class="absolute right-4 top-4 z-10 flex h-9 w-9 items-center justify-center rounded-full text-[var(--p-text-muted-color)] transition hover:bg-[var(--p-surface-200)] hover:text-[var(--p-text-color)] disabled:cursor-not-allowed disabled:opacity-50 dark:hover:bg-[var(--p-surface-800)] cursor-pointer"
      :aria-label="$t('general.close')"
      @click="handleClose"
    >
      <X :size="20" />
    </button>


    <div class="flex justify-center">
      <div class="w-full">
        <div class="p-5">
          <div class="flex flex-col gap-5 items-center justify-center">
            <div>
              <div class="flex flex-row items-center gap-3">
                <div class="w-fit bg-[var(--p-primary-color)]/20 p-1 rounded-md shrink-0">
                  <IconChatTransfer width="30" height="30" class="text-[var(--p-primary-color)]" />
                </div>

                <label
                  class="montserrat text-xl sm:text-2xl font-semibold text-red-600 dark:text-red-400"
                >
                  Transferencia rechazada
                </label>
              </div>
            </div>

            <div class="flex flex-row items-center gap-4 text-center">
              <label
                class="mt-1 text-md font-medium text-[var(--p-primary-color)] dark:text-[var(--p-surface-400)]"
              >
                {{ t('whatsapp.transfer_not_acepted') }}
              </label>
            </div>
          </div>

          <div class="mt-15">
            <TransferSummaryCards
              :contact-name="contactName"
              :contact-phone="contactPhone"
              :is-accepted="false"
              transfer-type="user"
              :destination-name="destinationName"
              :destination-subtitle="destinationSubtitle"
              :destination-meta="destinationMeta"
              :layout="hasDestinationSummary ? 'pair' : 'single'"
            />
          </div>

          <!-- <Message severity="warn" :closable="false" size="small" class="mt-4">
            El chat volverá a estar en tu lista de conversaciones activas.
          </Message> -->

          <div class="flex flex-row w-full justify-center items-center gap-5 mt-10">
            <AppButtonIcon
              label="Volver al chat"
              severity="primary"
              text
              class="!text-md montserrat"
              size="small"
              @click="handleBackToChat"
            />
            <AppButtonIcon
              label="Cambiar destino"
              severity="primary"
              text
              size="small"
              class="!text-md montserrat"

              :disabled="!canRetryTransfer"
              @click="handleChangeDestination"
            />
            <AppButtonIcon
              label="Reintentar"
              severity="primary"
              size="small"
              class="!text-md montserrat"

              :disabled="!canRetryTransfer"
              @click="handleRetry"
            />
          </div>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import Dialog from 'primevue/dialog'
import Message from 'primevue/message'
import TransferSummaryCards from '@/components/whatsapp/organisms/dialogs/steps-transfers/TransferSummaryCards.vue'
import IconChatTransfer from '@/assets/svg/transfer_chat_icon.svg?component'
import AppButtonIcon from '@/components/atoms/buttons/AppButtonIcon.vue'
import { useI18n } from 'vue-i18n'
import { X } from 'lucide-vue-next'

const { t } = useI18n()

interface Props {
  visible: boolean
  chatId: string
  contactName: string
  contactPhone: string
  destinationName?: string
  destinationSubtitle?: string | null
  destinationMeta?: string | null
  canRetryTransfer?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  destinationName: '',
  destinationSubtitle: null,
  destinationMeta: null,
  canRetryTransfer: false,
})

const emit = defineEmits<{
  (e: 'update:visible', value: boolean): void
  (e: 'back-to-chat'): void
  (e: 'change-destination'): void
  (e: 'retry'): void
}>()

const isVisible = computed({
  get: () => props.visible,
  set: (value) => emit('update:visible', value),
})

const hasDestinationSummary = computed(() => Boolean(props.destinationName))

let autoCloseTimer: number | undefined

watch(
  () => props.visible,
  (visible) => {
    if (!visible) return

    if (autoCloseTimer) {
      clearTimeout(autoCloseTimer)
    }

    autoCloseTimer = window.setTimeout(() => {
      handleClose()
    }, 115000)
  },
  { immediate: true },
)

const handleClose = () => {
  if (autoCloseTimer) {
    clearTimeout(autoCloseTimer)
    autoCloseTimer = undefined
  }

  emit('update:visible', false)
}

const handleBackToChat = () => {
  handleClose()
  emit('back-to-chat')
}

const handleChangeDestination = () => {
  handleClose()
  emit('change-destination')
}

const handleRetry = () => {
  handleClose()
  emit('retry')
}
</script>
